import React from 'react';

/**
 * LuxeCompassWatermark
 * Faint compass emblem watermark with a slow gold sheen sweep.
 * Drop into a position:relative parent (e.g. the unified-content-section
 * of a marketing page) to create shared visual DNA with the Pricing
 * waypoints — without competing with that page's "crown jewel" status.
 *
 * Respects prefers-reduced-motion (animation skipped by CSS).
 */
const LuxeCompassWatermark = () => (
  <span className="luxe-compass-watermark" aria-hidden="true" />
);

export default LuxeCompassWatermark;
